import React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

export default function LabelCheckbox({
  label,
  checked,
  onChange,
  value,
  color
}) {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} value={value} />}
      label={label}
      color={color || "primary"}
    />
  );
}
